import { type CategoryWithShows, type TvShowCategory } from '@setplex/tria-api'
import { type TFunction } from 'i18next'
import { type AdjustPurchaseableFn } from '~/features/payment/sse-purchases'
import { type ShowWithPrice } from '~/shared/interfaces'
import { extendMediaItemByLabelPrice } from '~/shared/tools'

interface FormatCategoriesWithShowsParams {
  categories: CategoryWithShows[] | null
  adjust: AdjustPurchaseableFn
  t: TFunction
}
export const formatCategoriesWithShows = ({
  categories,
  adjust,
  t,
}: FormatCategoriesWithShowsParams) => {
  if (!categories?.length) return null

  return categories.map((category) => {
    const shows = category.content.map(
      (tvShow) => extendMediaItemByLabelPrice(adjust(tvShow)) as ShowWithPrice
    )

    return {
      ...category,
      content: shows,
      nameFormatted: `${category.name} ${t('genre_other')}`,
    }
  })
}

interface FormatTvShowCategoryWithNameParams {
  category: TvShowCategory | null
  t: TFunction
}

export const formatTvShowCategoryWithName = ({
  category,
  t,
}: FormatTvShowCategoryWithNameParams) => {
  if (!category) return null

  return {
    ...category,
    nameFormatted: `${category.name} ${t('genre_other')}`,
  }
}
